import { makeAutoObservable, runInAction } from "mobx";
import ShipByReturnGoService from "../../../../services/api/ship-by-returngo-service";
import { rootContainer, TYPE } from "../../../../services/container/root";

class ShowSBRPageStore {
    private _show: boolean = false;
    private _loaded: boolean = false;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get show(): boolean { return this._show; }

    private get service(): ShipByReturnGoService {
        return rootContainer.get<ShipByReturnGoService>(TYPE.ShipByReturnGoService);
    }
    
    /** This method should be called from rma-list page and from rma-page and need to make sure we load only once,
     * Possible cases:
     * 1. first rma list page was opened and need to fetchShowSBRPageOnce; and then do not fetch on navigating between RMAs 
     * 2. single rma link was opened and need to fetchShowSBRPageOnce; and then do not fetch on moving rma-list pahe
     */
    async fetchShowSBRPageOnce() {
        if (this._loaded) {
            return;
        }

        try {
            const res = await this.service.getShowSbrPromotionPage();
            runInAction(() => {
                this._show = res.show;
                this._loaded = true;
            });
        } catch (e) {
            console.error(e);
            /** Do not show SBR promo page/promo text if not received response */
            runInAction(() => {
                this._show = false;
            })
        }
    }
}

export default new ShowSBRPageStore();